import styles from "./InputField.module.scss";
import { useState } from "react";

const TextField = ({
  type = "text",
  name,
  label,
  register,
  validation = {},
  errors,
  required = false,
  placeholder = "",
  autocomplete = null,
  isStatic = false,
  readOnly = false,
  onChange = () => {},
  onBlur = () => {},
  list = null,
  datalistOptions = [],
  watch = null,
}) => {
  /**** type="password"のときに使用 ****/
  const [isRevealPassword, setIsRevealPassword] = useState(false);

  const togglePassword = () => {
    setIsRevealPassword((prevState) => !prevState);
  };

  const inputtype = () => {
    if (type !== "password") {
      return type;
    } else if (isRevealPassword) {
      return "text";
    } else {
      return "password";
    }
  };

  const inputMax = () => {
    if (type === "date") {
      return "9999-12-31";
    } else if (type === "datetime-local") {
      return "9999-12-31T23:59";
    } else {
      return null;
    }
  };

  const showStaticLabel = isStatic && typeof watch === "function";

  return (
    <div className={styles.field} hidden={type === "hidden"}>
      <label className={`form-label ${styles.field__label}`}>
        {label}
        <span className={styles.field__label__required}>
          {required && !isStatic ? "必須" : ""}
        </span>
      </label>

      <input
        className={`${styles.field__input} ${
          errors[name] ? "is-invalid" : ""
        } ${
          showStaticLabel
            ? "d-none"
            : isStatic
              ? "form-control-plaintext"
              : "form-control"
        }`}
        type={inputtype()}
        placeholder={isStatic ? "" : placeholder}
        {...register(name, {
          ...validation,
          onChange: onChange,
          onBlur: onBlur,
        })}
        autoComplete={
          autocomplete !== null
            ? autocomplete
            : type === "password"
              ? "new-password"
              : list
                ? "off"
                : "on"
        }
        readOnly={isStatic || readOnly}
        max={inputMax()}
        list={list}
      />
      {showStaticLabel ? (
        <div className={`${styles.staticlabel} form-control-plaintext`}>
          {watch(name) ?? ""}
        </div>
      ) : (
        <></>
      )}
      {list && datalistOptions.length > 0 && (
        <datalist id={list}>
          {datalistOptions.map((option, index) => (
            <option key={index} value={option} />
          ))}
        </datalist>
      )}
      <>
        {type === "password" ? (
          <input
            type="button"
            className={
              isRevealPassword
                ? styles.mypagepassword__display02
                : styles.mypagepassword__display01
            }
            value={isRevealPassword ? "非表示" : "表示"}
            onClick={() => togglePassword()}
          />
        ) : (
          <></>
        )}
      </>
      <p className={`invalid-feedback ${styles.field__msg}`}>
        {errors[name] ? errors[name].message : ""}
      </p>
    </div>
  );
};

export default TextField;
